import React from "react";
import { Mutation } from "react-apollo";
import Button from "@streeteasy/design-system/deprecated/Button";
import Input from "@streeteasy/design-system/deprecated/Input";
import Text from "@streeteasy/design-system/deprecated/Text";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { func, object, shape, string } from "prop-types";

import { resetPasswordGA } from "../../../../analytics/ga";
import RESET_PASSWORD from "../../../../mutations/reset_password";
import {
  ModalButton,
  ModalHeading,
  ModalInput,
  ModalText,
  ModalTitle,
  SecondaryButton,
  XButtonWrapper
} from "../../styled";

class ResetPassword extends React.Component {
  static defaultProps = {
    formError: ""
  };

  static propTypes = {
    form: shape({
      data: object,
      email: string
    }).isRequired,
    formError: string,
    handleCloseModal: func.isRequired,
    handleInputChange: func.isRequired,
    handleMutationError: func.isRequired,
    handleRenderError: func.isRequired,
    setScenario: func.isRequired
  };

  // GA starts
  componentDidMount() {
    this.analyticsData = JSON.parse(localStorage.getItem("analytics")) || "";
    const { flow, source } = this.analyticsData;
    resetPasswordGA.forgotPasswordModalOpens(source, flow);
  }
  // GA ends

  handleSubmitResetPassword = mutationQuery => {
    mutationQuery({
      variables: {
        data: JSON.stringify(this.props.form.data),
        email: this.props.form.email
      }
    });
  };

  handleCompletedResetPassword = () => {
    // GA starts
    const { flow, source } = this.analyticsData;

    resetPasswordGA.forgotPasswordModalSibmit(source, flow);
    // GA ends

    this.props.setScenario("ResetPasswordConfirmation");
  };

  render() {
    const { handleMutationError } = this.props;

    return (
      <div>
        <ModalHeading>
          <ModalTitle type="primarySm">Recover your password</ModalTitle>
          <XButtonWrapper>
            <XButton onClick={this.props.handleCloseModal} />
          </XButtonWrapper>
        </ModalHeading>
        <ModalText>
          <Text type="sm">
            No worries. Enter your email and we’ll send you instructions on how
            &nbsp;to get into your account.
          </Text>
        </ModalText>
        <Mutation
          mutation={RESET_PASSWORD}
          onCompleted={this.handleCompletedResetPassword}
          onError={handleMutationError}
        >
          {mutationQuery => (
            <form
              onSubmit={e => {
                e.preventDefault();
                this.handleSubmitResetPassword(mutationQuery);
              }}
            >
              <ModalInput>
                <Input
                  autoFocus
                  isInvalid={this.props.formError}
                  name="email"
                  onChange={this.props.handleInputChange}
                  placeholder="Email"
                />
              </ModalInput>
              {this.props.handleRenderError()}
              <ModalButton>
                <Button theme="primary" type="submit">
                  Reset Password
                </Button>
              </ModalButton>
            </form>
          )}
        </Mutation>
        <SecondaryButton>
          <TextLink onClick={() => this.props.setScenario("EmailCapture")}>
            Back To Sign In
          </TextLink>
        </SecondaryButton>
      </div>
    );
  }
}

export default ResetPassword;
